import SvgIcon from '@mui/material/SvgIcon';
import { SvgIconProps } from '@mui/material/SvgIcon/SvgIcon';
import styled from '@mui/material/styles/styled';

export const Container = styled('div')`
  //width: 220px;
  width: fit-content;
  cursor: pointer;
  padding-top: 5px;
  padding-bottom: 5px;
  max-width: 100%;

  img {
    max-width: 220px;
  }
`;

export const LogoIcon = styled(SvgIcon)<SvgIconProps>(() => ({
  width: '6.25rem',
  height: '1.125rem',
  maxWidth: 220,
  cursor: 'pointer',
  paddingTop: 5,
  paddingBottom: 5,
}));
